import Actions from './container/index';

export default Actions;



// WEBPACK FOOTER //
// ./src/views/ReportFilters/components/Actions/index.js